import { ref } from "@nuxtjs/composition-api";
import { get } from "lodash";
import { toLower } from "lodash";

export default function useJsSearch() {
    const _comments = ref([]);
    const searchIndex = ref([]);
    function search(keywords = '') {
        if (!keywords) {
            return _comments.value;
        }
        return _comments.value.filter((comment) => {
            const values = searchIndex.value.map(path => get(comment, path, ''))
            return values.some(value => toLower(value).search(toLower(keywords)) >= 0);
        });
    }
    return {
        addIndex: (index) => searchIndex.value.push(index),
        setComments: (comments) => _comments.value = comments,

        search
    }
} 